// Pills current list flow
export const FETCH_DAYTODAY_PILLS_DATA = 'FETCH_DAYTODAY_PILLS_DATA';
export const FETCH_DAYTODAY_PILLS_DATA_DONE = 'FETCH_DAYTODAY_PILLS_DATA_DONE';
export const FETCH_PILLS_DATA = 'FETCH_PILLS_DATA';
export const FETCH_PILLS_DATA_DONE = 'FETCH_PILLS_DATA_DONE';
export const FETCH_PILLS_DATA_ERR = 'FETCH_PILLS_DATA_ERR';
export const FETCH_PILLS_DATA_CAREGIVER = 'FETCH_PILLS_DATA_CAREGIVER';
// Pills add and edit flow
export const SET_EVERYDAY_PILLS_DATA = 'SET_EVERYDAY_PILLS_DATA';
export const RESET_PILL_ERROR = 'RESET_PILL_ERROR';
export const ADD_PILL = 'ADD_PILL';
export const ADDING_PILLS_DONE = 'ADDING_PILLS_DONE';
export const ADDING_PILLS_DONE_FRE = 'ADDING_PILLS_DONE_FRE';
export const ADDING_PILLS_ERR = 'ADDING_PILLS_ERR';
export const MOVE_PILL = 'MOVE_PILL';
export const REMOVE_PILL = 'REMOVE_PILL';
export const REMOVING_PILLS_DONE = 'REMOVING_PILLS_DONE';
export const REMOVING_PILLS_ERR = 'REMOVING_PILLS_ERR';
// Other
// Pills save config
export const SAVE_CONFIG = 'SAVE_CONFIG';
export const SAVE_CONFIG_DONE = 'SAVE_CONFIG_DONE';
export const SAVE_CONFIG_ERR = 'SAVE_CONFIG_ERR';
// Other
export const SET_PILL_REFILL_STATE = 'SET_PILL_REFILL_STATE';
export const RECONNECT_HERO_DONE = 'RECONNECT_HERO_DONE';
//# sourceMappingURL=actionTypes.js.map